<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Danh sách phòng thi</h2>
        <el-button @click="createModel" size="small" type="info" class="btn-create">Tạo mới phòng thi</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="10">
          <el-popover placement="bottom" title="Sắp xếp theo" width="400" trigger="click" content="Nội dung">
            <div class="model-filter-radio" v-for="(item, index) in sort" :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio v-for="(itemSort, index_itemSort) in item.groupFiled" :key="index_itemSort" v-model="filter.sort"
                :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="8"></el-col>
        <el-col :span="5">
          <el-input placeholder="Tìm kiếm ..." class="input-seach" clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'" v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
        <el-pagination background layout="prev, pager, next" :page-size="table.pagination.per_page"
          :pager-count="table.pagination.count" :current-page="table.pagination.current_page"
          :total="table.pagination.total" @current-change="changeCurrentPage">
        </el-pagination>
        <div>
          Hiển thị tới <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{
            table.pagination.total }}</strong> danh sách phòng thi
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table v-loading="loading" border :data="table.database" style="width: 100%">
          <el-table-column label="#" type="index" width="40">
          </el-table-column>
          <el-table-column width="200" label="Tên lớp học">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Tên đề thi">
            <template slot-scope="scope">
              <div class="courses-info">
                <span>{{ scope.row.test_kit ? scope.row.test_kit.name : '' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Số học sinh">
            <template slot-scope="scope">
              <div class="courses-info">
                <span>{{ scope.row.users.length }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="150" label="Ngày tạo">
            <template slot-scope="scope">
              <span>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column width="180" label="Hành động" header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Kết quả thi" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Bookings',
  metaInfo() {
    return {
      title: 'Danh sách học'
    }
  },
  data() {
    return {
      loading: false,
      searching: false,
      searchCOD: false,
      filter: {
        q: '',
        status: '',
        category_course_id: '',
        orderbook_id: null,
        one_part: null,
        ship_code: null,
        teacher_id: '',
        daterange: '',
        page: 1,
        limit: 15,
        sorted: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Thòi gian',
          groupFiled: [
            { label: 'created_at:-1', text: 'Tăng dần' },
            { label: 'created_at:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {

      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted() {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb() {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'bookings-index', text: 'Danh sách học' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel() {
      this.$router.push({ name: 'test-room-create' })
    },
    // Fetch dữ liệu
    fetchDatabaseModel() {
      this.loading = true
      axios.get('get-test-room', { params: this.filter }).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data.data
            this.table.pagination = {
              total: response.data.total,
              count: response.data.data.length,
              per_page: response.data.per_page,
              current_page: response.data.current_page,
              total_pages: Math.ceil(response.data.total / response.data.per_page)
            }
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination() {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel(model) {
      this.$router.push({ name: 'test-room-show', params: { id: model.id } })
    },
    updateModel(model) {
      this.$router.push({ name: 'bookings-update', params: { course_id: model.id } })
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus(model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('bookings/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel(model) {
      this.$confirm('Xác nhận xóa lịch học: ' + model.course_text + ' của : ' + model.user_txt, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel(model) {
      axios.delete('bookings/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal(model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage(currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },
    // Search những khóa học có ship CODE CODE
    changeSearchCOD() {
      if (this.searchCOD) {
        this.filter.orderbook_id = 0
        this.filter.one_part = 0
        this.filter.status = 0
        this.filter.ship_code = true
      } else {
        this.filter.orderbook_id = null
        this.filter.one_part = null
        this.filter.status = ''
        this.filter.ship_code = null
      }

      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.model-filter-radio {
  margin-bottom: 10px;
}

.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}

.course-image {
  width: 150px;
  border-radius: 2px;
}

.courses-info {
  display: flex;
  flex-direction: column;
}

.courses-info span {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/test-rooms/Index.vue